// extracted by mini-css-extract-plugin
export default {"fallback":"ErrorBoundary_fallback__bQSlX","title":"ErrorBoundary_title__7L3Wx","message":"ErrorBoundary_message__x77Ff","button":"ErrorBoundary_button__OHBLY"};